import { render, staticRenderFns } from "./activeNewForm.vue?vue&type=template&id=6034def8&scoped=true&"
import script from "./activeNewForm.vue?vue&type=script&lang=js&"
export * from "./activeNewForm.vue?vue&type=script&lang=js&"
import style0 from "./activeNewForm.vue?vue&type=style&index=0&id=6034def8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6034def8",
  null
  
)

export default component.exports